import { createSelector } from "reselect";
import getDomain from "../base_getters/get_domain";

const getPhotoSessionsById = createSelector([
  getDomain
], (domain) => domain.photoSessions.byId);

export default getPhotoSessionsById;
